import { render, staticRenderFns } from "./ManageFlag.vue?vue&type=template&id=156d6cef&scoped=true&"
import script from "./ManageFlag.vue?vue&type=script&lang=js&"
export * from "./ManageFlag.vue?vue&type=script&lang=js&"
import style0 from "./ManageFlag.vue?vue&type=style&index=0&id=156d6cef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d6cef",
  null
  
)

export default component.exports